// Country URL aliases (e.g. /thailand-jobs) are generated from the country
// profiles — adding a country to config/countries.js creates its URLs here.
import { countryRouteAliases } from "../config/countries";

export const WebsiteRoute = [
  {
    path: "/error-404",
    name: "error-404",
    component: () => import(/* webpackChunkName: "web-error404" */ "../components/error/Error404.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  /** Make HomeNew.vue as a default page */
  {
    path: "/",
    name: "HomeNew",
    component: () => import(/* webpackChunkName: "web-home" */ "../components/website/HomeNew.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/singapore-jobs",
    alias: countryRouteAliases("/singapore-jobs"),
    component: () => import(/* webpackChunkName: "web-homepage" */ "../components/website/Index.vue"),
    name: "homepage",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/login-jobseeker",
    component: () => import(/* webpackChunkName: "web-login" */ "../components/website/login.vue"),
    name: "login",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/login-employer",
    component: () => import(/* webpackChunkName: "web-login-emp" */ "../components/website/loginEmp.vue"),
    name: "login-employer",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/v2/admin-login",
    name: "adminlogin",
    component: () => import(/* webpackChunkName: "web-admin-login" */ "../components/website/AdminLogin.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/signup-jobseeker",
    component: () => import(/* webpackChunkName: "web-signup" */ "../components/website/Signup.vue"),
    name: "signup",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/signup-employer",
    component: () => import(/* webpackChunkName: "web-signup-emp" */ "../components/website/SignupEmp.vue"),
    name: "signup-employer",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/forgotpassword",
    component: () => import(/* webpackChunkName: "web-forgot-password" */ "../components/website/ForgotPassword.vue"),
    name: "forgotpassword",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/resetpassword/:token/:id",
    component: () => import(/* webpackChunkName: "web-reset-password" */ "../components/website/ResetPassword.vue"),
    name: "resetpassword",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/unsubscribe-mail/:user_id",
    component: () => import(/* webpackChunkName: "web-unsubscribe-mail" */ "../components/website/unsubscribeMail.vue"),
    name: "unsubscribeMail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/email-verify/:token/:email",
    component: () => import(/* webpackChunkName: "web-email-verify" */ "../components/website/EmailVerify.vue"),
    name: "emailVerify",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/email-verify-emp/:token/:email",
    component: () => import(/* webpackChunkName: "web-email-verify-emp" */ "../components/website/EmailVerifyEmployer.vue"),
    name: "verifyEmployerEmail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/about-us",
    component: () => import(/* webpackChunkName: "web-about-us" */ "../components/website/AboutUs.vue"),
    name: "aboutUs",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/important-notice",
    component: () => import(/* webpackChunkName: "web-important-notice" */ "../components/website/importantNotice.vue"),
    name: "importantNotice",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/blog",
    component: () => import(/* webpackChunkName: "web-blog" */ "../components/website/Blog.vue"),
    name: "blog",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/blog/:id",
    component: () => import(/* webpackChunkName: "web-blog-detail" */ "../components/website/BlogDetail.vue"),
    name: "blogDetail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/website-service-category",
    component: () => import(/* webpackChunkName: "web-service-category" */ "../components/website/ServiceCategory.vue"),
    name: "websiteServiceCategory",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    // path: '/full-time-jobs-listing/',
    path: "/singapore-full-time-jobs/:role_type?/:category_id?/:company_id?/:location?/:keyword?/:tag?/:salary?",
    alias: countryRouteAliases("/singapore-full-time-jobs/:role_type?/:category_id?/:company_id?/:location?/:keyword?/:tag?/:salary?"),
    component: () => import(/* webpackChunkName: "web-all-jobs-listing" */ "../components/website/AllJobsListing.vue"),
    name: "allJobsListing",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/all-jobs-detail/:id",
    component: () => import(/* webpackChunkName: "web-all-jobs-detail" */ "../components/website/AllJobsDetail.vue"),
    name: "allJobsDetail",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/singapore-job-ad/:company_name/:job_alias/:id",
    alias: countryRouteAliases("/singapore-job-ad/:company_name/:job_alias/:id"),
    component: () => import(/* webpackChunkName: "web-all-jobs-detail-new" */ "../components/website/AllJobDetailNew.vue"),
    name: "allJobsDetailNew",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/web-emp-profile/view/:id",
    name: "web-emp-profile-view",
    route: "web-emp-profile-view",
    component: () => import(/* webpackChunkName: "web-emp-profile-view" */ "../components/website/WebEmpProfileView.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/web-emp-joblist/:id",
    name: "web-empJobList",
    route: "web-empJobList",
    component: () => import(/* webpackChunkName: "web-emp-joblist" */ "../components/website/WebEmpJobList.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/faq",
    component: () => import(/* webpackChunkName: "web-faq" */ "../components/website/Faq.vue"),
    name: "faq",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/training",
    component: () => import(/* webpackChunkName: "web-training" */ "../components/website/Training.vue"),
    name: "training",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/terms-of-service",
    component: () => import(/* webpackChunkName: "web-terms" */ "../components/website/TermsConditions.vue"),
    name: "TermsConditions",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/em-terms-of-service",
    component: () => import(/* webpackChunkName: "web-terms-emp" */ "../components/website/TermsConditionsEmp.vue"),
    name: "TermsConditionsEmp",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/privacy-policy",
    component: () => import(/* webpackChunkName: "web-privacy-policy" */ "../components/website/PrivacyPolicy.vue"),
    name: "PrivacyPolicy",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/privacy-policy/#account-deletion",
    component: () => import(/* webpackChunkName: "web-privacy-policy" */ "../components/website/PrivacyPolicy.vue"),
    name: "PrivacyPolicy",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/job",
    name: "jobData",
    route: "jobData",
    component: () => import(/* webpackChunkName: "web-job-data" */ "../components/jobData.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/job-part-time",
    name: "jobDataDaily",
    route: "jobDataDaily",
    component: () => import(/* webpackChunkName: "web-job-data-daily" */ "../components/jobDataDaily.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/ptjob/:id",
    name: "dpJobsDetail",
    route: "dpJobsDetail",
    component: () => import(/* webpackChunkName: "web-dp-jobs-detail" */ "../components/dpJobsDetail.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/reward-detail/:id",
    name: "rewardDetail",
    route: "rewardDetail",
    component: () => import(/* webpackChunkName: "web-reward-detail" */ "../components/rewardDetail.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/career-advice",
    name: "CareerAdvice",
    route: "CareerAdvice",
    component: () => import(/* webpackChunkName: "web-career-advice" */ "../components/website/CareerAdvice.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/career-with-us",
    name: "CareerWithUs",
    route: "CareerWithUs",
    component: () => import(/* webpackChunkName: "web-career-with-us" */ "../components/website/CareerWithUs.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/data-protection-policy",
    name: "DataProtectionPolicy",
    route: "DataProtectionPolicy",
    component: () => import(/* webpackChunkName: "web-data-protection-policy" */ "../components/website/DataProtectionPolicy.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/advertising-terms-and-conditions",
    name: "AdvertisingTermsConditions",
    route: "AdvertisingTermsConditions",
    component: () => import(/* webpackChunkName: "web-advertising-terms" */ "../components/website/AdvertisingTermsConditions.vue"),
    meta: { requiresAuth: false, hideForAuth: true },
  },
  // { path: "/gigplace", name: "Gigplace", route: "Gigplace", component: Gigplace, meta: { requiresAuth: false, hideForAuth: true } }, // gigplace disabled
  {
    path: "/promotion-detail/:id",
    component: () => import(/* webpackChunkName: "web-promotion-detail" */ "../components/website/PromotionDetail.vue"),
    name: "allPromotionDetail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/all-promotion-list",
    component: () => import(/* webpackChunkName: "web-promotion-listing" */ "../components/website/allPromotionlisting.vue"),
    name: "allPromotionlisting",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/contact-us",
    component: () => import(/* webpackChunkName: "web-contact" */ "../components/website/Contact.vue"),
    name: "ContactUs",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/pt-jobs-detail/:id",
    component: () => import(/* webpackChunkName: "web-dp-job-detail" */ "../components/website/allDailyPaidJobDetail.vue"),
    name: "allDailyPaidJobDetail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/singapore-jobs-part-time/:company_name/:job_alias/:id",
    alias: countryRouteAliases("/singapore-jobs-part-time/:company_name/:job_alias/:id"),
    component: () => import(/* webpackChunkName: "web-dp-job-detail-new" */ "../components/website/allDailyPaidJobDetailNew.vue"),
    name: "allDailyPaidJobDetailNew",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/gig-missions",
    component: () => import(/* webpackChunkName: "web-gig-landing" */ "../components/website/GigMissionsLanding.vue"),
    name: "GigMissionsLanding",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/singapore-gig-mission",
    alias: countryRouteAliases("/singapore-gig-mission"),
    redirect: to => {
      const { gigID, alias } = to.query;
      if (gigID && alias) {
        // to.path is whichever country prefix was visited — keep it.
        return { path: `${to.path}/${alias}/${gigID}` };
      }
      return { name: "allGigMissionListing" };
    },
  },
  {
    path: "/singapore-gig-mission/:gig_alias/:id",
    alias: countryRouteAliases("/singapore-gig-mission/:gig_alias/:id"),
    component: () => import(/* webpackChunkName: "web-gig-detail" */ "../components/website/allGigMissionDetail.vue"),
    name: "allGigMissionDetail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/singapore-gig-missions/:category_id?/:keyword?",
    alias: countryRouteAliases("/singapore-gig-missions/:category_id?/:keyword?"),
    component: () => import(/* webpackChunkName: "web-gig-listing" */ "../components/website/allGigMissionListing.vue"),
    name: "allGigMissionListing",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    //path: "/singapore-part-time-jobs",
    path: "/singapore-part-time-jobs/:category_id?/:company_id?/:keyword?",
    alias: countryRouteAliases("/singapore-part-time-jobs/:category_id?/:company_id?/:keyword?"),
    // path: '/daily-paid-part-time-jobs-listing/:category_id?/:keyword?',
    component: () => import(/* webpackChunkName: "web-dp-job-listing" */ "../components/website/allDailyPaidJoblisting.vue"),
    name: "allDailyPaidJoblisting",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  // {
  //   path: '/admin-login',
  //   component:  v1AdminLogin,
  //   name: 'v1AdminLogin',
  //   meta: { requiresAuth: false, hideForAuth: true }
  // },

  {
    // path: "/jobseekers",
    path: "/jobseekers-old",
    component: () => import(/* webpackChunkName: "web-jobseekers-old" */ "../components/website/jobseekers_old.vue"),
    name: "jobseekers_old",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/admin-forgot-password",
    component: () => import(/* webpackChunkName: "web-admin-forgot-password" */ "../components/website/AdminForgotPassword.vue"),
    name: "adminforgotpassword",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/admin-resetpassword/:token/:id",
    component: () => import(/* webpackChunkName: "web-admin-reset-password" */ "../components/website/AdminResetPasswordPage.vue"),
    name: "AdminResetPasswordPage",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/job-part-time-list",
    component: () => import(/* webpackChunkName: "web-job-dp-list" */ "../components/website/jobDpList.vue"),
    name: "jobDpList",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/job-part-time-comp",
    component: () => import(/* webpackChunkName: "web-job-by-comp" */ "../components/website/jobByComp.vue"),
    name: "jobByComp",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/job-full-time-list",
    component: () => import(/* webpackChunkName: "web-job-ft-list" */ "../components/website/jobftList.vue"),
    name: "jobftList",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/singpass-login",
    component: () => import(/* webpackChunkName: "web-singpass-login" */ "../components/website/singpassLogin.vue"),
    name: "SingpassLogin",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/return-callback-data",
    component: () => import(/* webpackChunkName: "web-singpass-data" */ "../components/website/singpassData.vue"),
    name: "SingpassData",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/singpass-login/callback",
    component: () => import(/* webpackChunkName: "web-singpass-callback" */ "../components/website/SingpassLoginCallback.vue"),
    name: "SingpassLoginCallback",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/singpass-verify-email",
    component: () => import(/* webpackChunkName: "web-singpass-verify-email" */ "../components/website/verifyMail.vue"),
    name: "SingpassVerifyEmail",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/singpass-verify-mobile",
    component: () => import(/* webpackChunkName: "web-singpass-verify-mobile" */ "../components/website/verifyMobile.vue"),
    name: "SingpassVerifyMobile",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/chat",
    component: () => import(/* webpackChunkName: "web-chatbot" */ "../components/website/ChatBot.vue"),
    name: "ChatBot",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/resume-builder",
    component: () => import(/* webpackChunkName: "web-resume-builder" */ "../components/website/ResumeBuilders/ResumeBuilder.vue"),
    name: "ResumeBuilder",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  {
    path: "/rpa-testing1",
    component: () => import(/* webpackChunkName: "web-rpa-testing1" */ "../components/Rpa_Testing/RpaTesting1.vue"),
    name: "RpaTesting1",
    meta: { requiresAuth: false },
  },
  {
    path: "/rpa-testing2",
    component: () => import(/* webpackChunkName: "web-rpa-testing2" */ "../components/Rpa_Testing/RpaTesting2.vue"),
    name: "RpaTesting2",
    meta: { requiresAuth: false },
  },
  {
    path: "/rewards",
    component: () => import(/* webpackChunkName: "web-rewards" */ "../components/website/Rewards.vue"),
    name: "Rewards",
    meta: { requiresAuth: false, hideForAuth: true },
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   component: Home,
  //   meta: { requiresAuth: false, hideForAuth: true },
  // },
  {
    path: "/home-old",
    component: () => import(/* webpackChunkName: "web-home-old" */ "../components/website/HomeOld.vue"),
    name: "HomeOld",
    meta: { requiresAuth: false, hideForAuth: true },
  },

  {
    path: "/payment-success",
    component: () => import(/* webpackChunkName: "web-payment-success" */ "../components/website/paymentSuccess.vue"),
    name: "PaymentSuccess",
    meta: { requiresAuth: false, hideForAuth: true },
  },
];
